import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-hot-toast";

import useFullPageLoader from "hooks/useFullPageLoader";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import { Button } from "components/Button/Button";
import ModalBox from "components/modal/ModalBox";

import { getCityWiseNews, mapCityWiseNews } from "services/citypages";
import TextEditor from "components/TextEditor/TextEditor";
import { rawToHtmlConverter, wrapImagesWithFigure } from "utils";
import { ContentState, convertFromHTML, EditorState } from "draft-js";
// 👆 you'll need to implement these APIs similar to video

// import your TextEditor component

const CityWiseSubHeadingMapping = () => {
    const { cityid } = useParams();
    const navigate = useNavigate();

    const [Subheading, setSubheading] = useState("");
    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();

    const [assignModal, setAssignModal] = useState(false);

    // Fetch news
    const fetchNews = async () => {
        try {
            showLoader();
            const res = await getCityWiseNews({ cityid });
            hideLoader();
            if (res.code === 200) {
                setSubheading(EditorState.createWithContent(
                    ContentState.createFromBlockArray(
                        convertFromHTML(wrapImagesWithFigure(res.data?.subheading))
                    )
                ),);

            } else {
                toast.error(res.message);
            }
        } catch (err) {
            hideLoader();
            toast.error(err?.response?.data?.message || err.message);
        }
    };

    // Save/Assign news
    // Save/Assign news
    const assignHandler = async () => {
        try {
            setSubmitLoading(true);

            const htmlHeading = rawToHtmlConverter(Subheading.getCurrentContent());
            // 👆 converts Draft.js state into clean HTML string

            const res = await mapCityWiseNews({
                cityid,
                subheading: htmlHeading, // ✅ sending HTML instead of JSON
            });

            setSubmitLoading(false);

            if (res.code === 200) {
                toast.success(res.message);
                setAssignModal(false);
                navigate("/city-pages/city-wise-centers");
            } else {
                toast.error(res.message);
            }
        } catch (err) {
            setSubmitLoading(false);
            toast.error(err?.response?.data?.message || err.message);
        }
    };


    useEffect(() => {
        fetchNews();
        // eslint-disable-next-line
    }, [cityid]);

    return (
        <React.Fragment>
            <title>Shubhra Viraj | City Wise News</title>
            <div className="WrapperBox">
                <div className="Small-Wrapper">
                    {/* Heading aligned left */}
                    <div className="search_wrap d-flex align-items-center">
                        <h4 className="Title mb-0 flex-grow-1 text-start">
                            <Link to={-1} className="me-2">
                                <i className="fa fa-arrow-left"></i>
                            </Link>
                            City Wise Sub Heading
                        </h4>
                    </div>


                    {/* Text Editor */}
                    <div className="mt-3">
                        {loader}
                        <TextEditor value={Subheading} onChange={(val) => setSubheading(val)} />
                    </div>

                    {/* Save button centered */}
                    <div className="mt-4 text-center">
                        <Button
                            onClick={() => setAssignModal(true)}
                            {...submitButtonElement}
                        >
                            Save Sub-Heading
                        </Button>
                    </div>
                </div>
            </div>


            {/* Confirm Save Modal */}
            <ModalBox
                status={assignModal}
                onClose={() => setAssignModal(false)}
                title={"Save Sub-Heading"}
                description={"Are you sure you want to save this subheading ?"}
                customizedFooter={
                    <Button onClick={assignHandler} {...submitButtonElement}>
                        Yes
                    </Button>
                }
            />
        </React.Fragment>
    );
};

export default CityWiseSubHeadingMapping;
